import React from "react";
import founder1 from "../../assests/Santhosh_M.png";
import founder2 from "../../assests/Susan_M.png";

import { Header } from '../Header';
import { Footer } from '../Footer';
import { Link } from 'react-router-dom';
import { useEffect } from "react";


function Founder() {
  useEffect(() => {
    // Set the scroll position when the component mounts
    window.scrollTo(0, 0); // Adjust the '500' value as needed
  }, []);
  return (
    <>
      <Header />
      <section
        className="founder"
        style={{ minHeight: "100vh" }}
      ></section>



      <section style={{ minHeight: "90vh" }}>
        <div className="container">
          <div className="row d-flex justify-content-center "></div>

          <div className="row mt- d-flex justify-content-center align-items-center mt-3">
            <div className="col-md-4 mt-3">
              <img className=" img-fluid  founders" src={founder2} />
            </div>
            <div className="col-md-6  text-justify text-black mt-4 ">
              <h2 className="text-danger  mb-3 fw-bold px-4 ">SUSAN MATHEWS</h2>
              <p style={{ fontSize: "20px" }} className="px-4 india-text">
                Susan Mathews is an author, speaker, Chairwoman and co-founder of Love
                Without Reason. There is plenty of humor and inspiration to
                share as a mother of three children. Raising a child with
                multiple craniofacial differences to excel against all the
                medical odds and graduate from high school is a story she shares
                around the globe. Grieving the loss of a child and picking up
                the mantle of his dream is a challenge she inspires in her
                audience. After serving in the healthcare industry as a nurse
                and nurse practitioner, she laid down her stethoscope and picked
                up the spear to fight human trafficking.”
              </p>
            </div>
            <div className="col-md-10 p-4">
              <p className="india-text">
                She will continue
                Philip Mathews’ legacy and work “Until There Are No More Sold.
                Susan's experiences with her Philip, Sara and Caleb birthed the material for her first book, "A Mother's Heart."  As a speaker she shares her story of a mother who chose life against all medical odds, balancing faith and family,  motherhood as a special needs parent and surviving child loss.
              </p>
            </div>

          </div>

        </div>

      </section>


      <section className="mb-4" style={{ minHeight: "70vh", backgroundColor: " #ffff" }}>
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-md-6 text-justify text-white">
              <h3 className="text-danger mb-3 fw-bold ">SANTHOSH MATHEWS</h3>
              <br></br>
              <p className="india-text text-dark" style={{ fontSize: "20px" }}>
                Santhosh Mathews is the innovator and creator behind Love
                Without Reason. With his background in counseling youth, working
                in the IT industry, and raising three children, including a son
                with craniofacial differences, his material for speaking and for
                blogging is never-ending. His passion to envision Love Without
                Reason began with the journey in raising his children Philip,
                Sara and Caleb.
              </p>
            </div>
            <div className="col-md-4 mt-5">
              <img className=" img-fluid founders" src={founder1} />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export { Founder };
